import { Pipe, PipeTransform } from '@angular/core';
import { ValidatedResource } from 'ngx-web-api';

@Pipe({
  name: 'valid',
})
export class ValidPipe implements PipeTransform {
  transform(resource: ValidatedResource): boolean {
    if (!!resource && resource instanceof ValidatedResource) {
      return resource.isValid();
    }
    return false;
  }
}
